// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__21wYP","title":"card_title__106TT","inActive":"card_inActive__3U9Bx"};